import { render } from "./honor.vue?vue&type=template&id=91171cea&scoped=true"
import script from "./honor.vue?vue&type=script&lang=js"
export * from "./honor.vue?vue&type=script&lang=js"

import "./honor.vue?vue&type=style&index=0&id=91171cea&lang=less&scoped=true"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91171cea"]])

export default __exports__